import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "antd";
import { useIntl } from "react-intl";

const ButtonDownloadStandard = props => {
  const { documentId, filename, getDownload, style } = props;

  const intl = useIntl();

  return (
    <div
      style={style}
      onClick={e => {
        e.stopPropagation();
      }}
    >
      <Tooltip placement="top" title={intl?.formatMessage({ id: "documents.download", defaultMessage: "Scarica documento"})} color={"#005075"}>
        <div
          onClick={e => {
            getDownload(
              e, documentId, filename
            );
          }}
          className={"gs-documents-download"}
          style={{
            width: "40px",
            cursor: "pointer",
            margin: "0 -15px",
            padding: "0 10px",
            textAlign: "center"
          }}
        >
          <FontAwesomeIcon
            icon={["far", "arrow-to-bottom"]}
            style={{
              cursor: "pointer",
              color: "#0090d1",
              fontSize: "16px"
            }}
          />
        </div>
      </Tooltip>
    </div>
  );
};

export default ButtonDownloadStandard;
